import {GESTION_CLIENTES_TYPES} from '../constants/gestionCliente.types'
import {gestionClienteInitialState} from '../initital-state/gestionCliente.state'
import {GestionClienteAction, GestionClienteState} from '../interfaces/gestion-cliente.interface'

const gestionClienteReducer = (
  state: GestionClienteState = gestionClienteInitialState,
  action: GestionClienteAction
): GestionClienteState => {
  switch (action.type) {
    // LISTAR CLIENTES
    case GESTION_CLIENTES_TYPES.LC_SET_ARRAY_CLIENTES:
      return {
        ...state,
        listarClientes: {...state.listarClientes, arrayClientes: action.payload},
      }

    case GESTION_CLIENTES_TYPES.LC_SET_CLIENTES:
      return {
        ...state,
        listarClientes: {...state.listarClientes, clientes: action.payload},
      }

    case GESTION_CLIENTES_TYPES.LC_FORM_BUSCAR:
      return {
        ...state,
        listarClientes: {
          ...state.listarClientes,
          formBuscar: {...state.listarClientes.formBuscar, ...action.payload},
        },
      }

    case GESTION_CLIENTES_TYPES.LC_CLEAR_FORM_BUSCAR:
      return {
        ...state,
        listarClientes: {
          ...state.listarClientes,
          formBuscar: gestionClienteInitialState.listarClientes.formBuscar,
        },
      }

    case GESTION_CLIENTES_TYPES.LC_CLEAR:
      return {
        ...state,
        listarClientes: gestionClienteInitialState.listarClientes,
      }

    case GESTION_CLIENTES_TYPES.LC_SET_CLIENTE_SELECCIONADO:
      return {
        ...state,
        listarClientes: {...state.listarClientes, clienteSeleccionado: action.payload},
      }

    case GESTION_CLIENTES_TYPES.LC_SHOW_MODAL_ELIMINAR_CLIENTE:
      return {
        ...state,
        listarClientes: {
          ...state.listarClientes,
          modales: {...state.listarClientes.modales, activeEliminar: action.payload},
        },
      }

    case GESTION_CLIENTES_TYPES.LC_SHOW_MODAL_ESTATUS:
      return {
        ...state,
        listarClientes: {
          ...state.listarClientes,
          modales: {...state.listarClientes.modales, activeEstatus: action.payload},
        },
      }

    // EDITAR CLIENTE
    case GESTION_CLIENTES_TYPES.EC_FORM_HANDLE_CHANGE:
      return {
        ...state,
        editarCliente: {
          ...state.editarCliente,
          formCliente: {...state.editarCliente.formCliente, ...action.payload},
        },
      }

    case GESTION_CLIENTES_TYPES.EC_FORM_ADD_ERROR:
      return {
        ...state,
        editarCliente: {
          ...state.editarCliente,
          errorsFormCliente: {...state.editarCliente.errorsFormCliente, ...action.payload},
        },
      }

    case GESTION_CLIENTES_TYPES.EC_SET_CLIENTE_SELECCIONADO:
      return {
        ...state,
        editarCliente: {
          ...state.editarCliente,
          clienteSeleccionado: action.payload,
          formCliente: action.payload,
        },
      }

    case GESTION_CLIENTES_TYPES.EC_CLEAR:
      return {
        ...state,
        editarCliente: gestionClienteInitialState.editarCliente,
      }

    // AGREGAR CLIENTE (carga masiva)
    case GESTION_CLIENTES_TYPES.AC_SET_FILE_DATA_CARGADA:
      return {
        ...state,
        agregarCliente: {...state.agregarCliente, clientesFileDataCargada: action.payload},
      }

    case GESTION_CLIENTES_TYPES.AC_CLEAR_FILE_DATA:
      return {
        ...state,
        agregarCliente: gestionClienteInitialState.agregarCliente,
      }

    default:
      return state
  }
}

export default gestionClienteReducer
